import validators from '../../utils/validators';
import QuestionnaireCategory from './category';

class Questionnaire {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      title: (v) => validators.isNotEmptyString(v),
      description: (v) => validators.isNotEmptyStringOrNull(v),
      published: (v) => validators.isBoolean(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid QuestionnaireCategory property '${property}' in ${data.id}`);
      }

      this[property] = data[property];
    }

    this.categories = [];

    if (Array.isArray(data.categories)) {
      for(const category of data.categories) {
        this.categories.push(new QuestionnaireCategory(category));
      }
    }
  }
}

export default Questionnaire;
